// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FacebookF = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M39.467 87.5V52.166H27.633V38.125h11.834V27.062c0-12.02 7.345-18.562 18.069-18.562 5.138 0 9.55.386 10.831.555v12.56H60.93c-5.832 0-6.959 2.778-6.959 6.836v9.674h13.162l-1.805 14.041H53.97V87.5"
			fillRule="evenodd"
		/>
	</svg>
);
export default FacebookF;
